export const selectRoleTranslation = {
  swicthingRoles: {
    key: 'selectRole.swicthingRoles',
    defaultValue: 'Assigning a new role...',
  },
  header: {
    key: 'selectRole.header',
    defaultValue: 'Want to select a new role?',
  },
  label: {
    key: 'selectRole.label',
    defaultValue: 'Select a role',
  },
  subHeader: {
    key: 'selectRole.subHeader',
    defaultValue: 'Select the role you want to work with. You can always switch to another role later.',
  },
  button: {
    key: 'selectRole.button',
    defaultValue: 'OK',
  },
  error: {
    key: 'selectRole.error',
    defaultValue: 'Could not assign you the selected role. \nTry again later!',
  },
};

export const requestAccessTranslation = {
  header: {
    key: 'selectRole.requestAccess.header',
    defaultValue: 'Request Access',
  },
  subHeader: {
    key: 'selectRole.requestAccess.subHeader',
    defaultValue: 'Select a specific role along with the businesses, organizations and brands for yourself.',
  },
  fetchingRoles: {
    key: 'selectRole.requestAccess.fetchingRoles',
    defaultValue: 'Fetching all roles',
  },

  errorFetchingRoles: {
    key: 'selectRole.requestAccess.errorFetchingRoles',
    defaultValue: 'Error fetching roles',
  },
  errorRequestAccess: {
    key: 'selectRole.requestAccess.errorRequestAccess',
    defaultValue: 'Something went wrong. \n Please try to request access again',
  },
  successRequestAccess: {
    title: {
      key: 'selectRole.requestAccess.successRequestAccess.title',
      defaultValue: 'Access requested successfully!',
    },
    subTitle: {
      key: 'selectRole.requestAccess.successRequestAccess.subTitle',
      defaultValue: `An email has been sent to your manager regarding your access. Once approved, you'll be able to access the Store Performance application!`,
    },
  },
  addAccess: {
    key: 'selectRole.requestAccess.addAccess',
    defaultValue: 'Add Access',
  },
  inputForm: {
    label: {
      organization: {
        key: 'selectRole.requestAccess.inputForm.label.organization',
        defaultValue: 'Organization',
      },
      business: {
        key: 'selectRole.requestAccess.inputForm.label.business',
        defaultValue: 'Business Unit',
      },
      brand: {
        key: 'selectRole.requestAccess.inputForm.label.brand',
        defaultValue: 'Brand',
      },
      country: {
        key: 'selectRole.requestAccess.inputForm.label.country',
        defaultValue: 'Country',
      },
    },
    placeholder: {
      selectOrganization: {
        key: 'selectRole.requestAccess.inputForm.selectOrganization',
        defaultValue: 'Select Organization',
      },
      selectBusiness: {
        key: 'selectRole.requestAccess.inputForm.selectBusiness',
        defaultValue: 'Select Business Unit',
      },
      selectBrand: {
        key: 'selectRole.requestAccess.inputForm.selectBrand',
        defaultValue: 'Select Brand',
      },
      selectCountry: {
        key: 'selectRole.requestAccess.inputForm.selectCountry',
        defaultValue: 'Select Country',
      },
    },
    button: {
      reset: {
        key: 'selectRole.requestAccess.inputForm.button.reset',
        defaultValue: 'Reset',
      },
      requestAccess: {
        key: 'selectRole.requestAccess.inputForm.button.requestAccess',
        defaultValue: 'Request Access',
      },
    },
  },
};
